'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grillStickyNavHandler = grillStickyNavHandler;

var _setup = require('./setup');

var $window = _setup.s.$window,
    $doc = _setup.s.$doc,
    $grillStickyNav = _setup.s.$grillStickyNav;
var headerHeight = _setup._s.headerHeight,
    didScroll = _setup._s.didScroll;


var $collectionSelect = $('#nx-grill-category .nx-stickynav__dropdown');
var $collectionSelectTitle = $('#nx-category-title');
var $collectionSelectOptionsParent = $('.nx-stickynav__dropdown-options');
var $collectionSelectOptions = $('.nx-stickynav__dropdown-option');
var $collectionSelectHeightTarget = $('.nx-stickynav__dropdown-options > div');

$doc.ready(function () {
  if (!$grillStickyNav.length) return;

  $grillStickyNav.css({
    top: headerHeight
  });

  $window.resize(function () {
    $grillStickyNav.css({
      top: headerHeight
    });
  });

  $collectionSelectOptions.each(function () {
    var $t = $(this);

    if ($t.hasClass('selected')) {
      $collectionSelectTitle.find('span').text($t.data('value'));
    }
  });

  $collectionSelectTitle.on('click', function () {
    if ($collectionSelect.hasClass('open')) {
      $collectionSelect.removeClass('open');
      $collectionSelectOptionsParent.height(0);
    } else {
      $collectionSelectOptionsParent.trigger('focus');
      $collectionSelect.addClass('open');
      $collectionSelectOptionsParent.height($collectionSelectHeightTarget.outerHeight());
    }
  });

  $collectionSelectOptionsParent.on('blur', function (_ref) {
    var currentTarget = _ref.currentTarget,
        relatedTarget = _ref.relatedTarget;

    if (!currentTarget.contains(relatedTarget)) {
      $collectionSelect.removeClass('open');
      $collectionSelectOptionsParent.height(0);
    }
  });
});

function grillStickyNavHandler() {
  if (didScroll) {
    if ($window.scrollTop() > headerHeight) {
      $grillStickyNav.addClass('is-traveling');
    } else {
      $grillStickyNav.removeClass('is-traveling');
      $grillStickyNav.css({ top: headerHeight });
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./_js/grill-sticky-nav.js
// module id = 4
// module chunks = 0